import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { PageBackHeaderPrimary } from './components/PageBackHeaderPrimary';

export type PageHeaderPrimaryProps = {
  children: ReactNode;
};

const Header = styled('header')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(4),
  paddingBottom: 0,
  gap: theme.spacing(1),
}));

export const PageHeaderPrimary = ({ children }: PageHeaderPrimaryProps) => {
  return <Header>{children}</Header>;
};

PageHeaderPrimary.Back = PageBackHeaderPrimary;
